import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=f6327b18&"
import script from "./NewHome.vue?vue&type=script&lang=js&"
export * from "./NewHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports